import { NavLink } from "react-router-dom";

function SectionServices1() {
  return (
    <>
      <div className="section-full p-t20 p-b10 sx-our-services-outer sx-bg-light">
        <div className="container">
          {/* TITLE START */}
          <div className="section-head center">
            <div className="sx-head-s-title"></div>
            <div className="sx-head-l-title">
              <h2 className="sx-title">Our Services</h2>
            </div>
          </div>
          {/* TITLE END */}
          <div className="section-content">
            <div className="sx-our-services-bx">
              <div className="row">
                {/* Block one */}
                <div
                  className="col-lg-4 col-md-6 wow fadeInDown"
                  data-wow-duration="1000ms"
                >
                  <div className="sx-service-bx-1">
                    <div className="sx-icon-box-wraper">
                      <div className="sx-service-bx-icon scale-in-center">
                        <span className="sx-text-primary">
                          <i className="flaticon-development" />
                        </span>
                      </div>
                      <div className="icon-content">
                        <h4 className="sx-tilte">Website Development</h4>
                        <p>
                          As one of the trusted website development companies in
                          Pune, we build fast, responsive, and SEO-friendly
                          websites that convert visitors into customers.
                        </p>
                        <div className="sx-center-btn">
                          <NavLink
                            to="/services/web-development/"
                            className="site-button-circle"
                          >
                            <i className="fa fa-long-arrow-right" />
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Block Two */}
                <div
                  className="col-lg-4 col-md-6 wow fadeInDown"
                  data-wow-duration="1000ms"
                >
                  <div className="sx-service-bx-1">
                    <div className="sx-icon-box-wraper">
                      <div className="sx-service-bx-icon scale-in-center">
                        <span className="sx-text-primary">
                          <i className="flaticon-coding" />
                        </span>
                      </div>
                      <div className="icon-content">
                        <h4 className="sx-tilte">
                          Mobile Application Development
                        </h4>
                        <p>
                          We develop secure, scalable, and high-performance
                          mobile applications for Android and iOS tailored to
                          your business needs.
                        </p>
                        <div className="sx-center-btn">
                          <NavLink
                            to="/services/mobile-app-development"
                            className="site-button-circle active"
                          >
                            <i className="fa fa-long-arrow-right" />
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Block Three */}
                <div
                  className="col-lg-4 col-md-6 wow fadeInDown"
                  data-wow-duration="1000ms"
                >
                  <div className="sx-service-bx-1">
                    <div className="sx-icon-box-wraper">
                      <div className="sx-service-bx-icon scale-in-center">
                        <span className="sx-text-primary">
                          <i className="flaticon-smart-contracts" />
                        </span>
                      </div>
                      <div className="icon-content">
                        <h4 className="sx-tilte">
                          Digital <br /> Marketing
                        </h4>
                        <p>
                          Our data-driven digital marketing strategies help you
                          increase online visibility, generate quality leads,
                          and grow your business.
                        </p>
                        <div className="sx-center-btn">
                          <NavLink
                            to="/services/digital-marketing"
                            className="site-button-circle"
                          >
                            <i className="fa fa-long-arrow-right" />
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionServices1;
